import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Calendar2, CardText, Cash, Clock, PersonWorkspace, TextParagraph, Wifi } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import imageCompression from "browser-image-compression";

export default function ForfaitInfos({ codeforfait }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [compressing, setCompressin] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suspending, setSuspending] = useState(false);
    const [starting, setStarting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [idrouteur, setidrouteur] = useState("");
    const [lib, setlib] = useState("");
    const [profile, setprofile] = useState("");
    const [desc, setdesc] = useState("");
    const [duree, setduree] = useState("");
    const [prix, setprix] = useState("");
    const [nbposte, setnbposte] = useState("");
    const [qte, setqte] = useState("");
    const [qtejour, setqtejour] = useState("");
    const [uniteqte, setuniteqte] = useState("");
    const [uniteqtejour, setuniteqtejour] = useState("");
    const [typeforfait, settypeforfait] = useState('');
    const [typeforfaitsList, settypeforfaitsList] = useState([]);
    const [hotspot, sethotspot] = useState('');
    const [hotspotsList, sethotspotsList] = useState([]);
    const [site, setsite] = useState('');
    const [sitesList, setsitesList] = useState([]);
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);
    const [picture, setPicture] = useState('');
    const [pictureprev, setPictureprev] = useState('/assets/imgs/no-image.png');
    const [unite, setUnite] = useState({ label: "Jour (s)", value: "days" });

    const unites = [
        {
            label: "Jour (s)",
            value: "days",
        },
        // {
        //     label: "Mois",
        //     value: "months",
        // },
    ];

    const unitedatas = [
        {
            label: "Go",
            value: 0,
        },
        {
            label: "Mo",
            value: 1,
        },
    ];


    const paksList = [
        {
            label: "Y-Day",
            value: "1",
        },
        {
            label: "Y-3Days",
            value: "3",
        },
        {
            label: "Y-Week",
            value: "7",
        },
        {
            label: "Y-Month",
            value: "30",
        },
    ];

    const [datecrea, setDatecrea] = useState("");
    const [etat, setEtat] = useState(0);
    const [etatdef, setetatdef] = useState("");


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getTypeForfaitsList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=tforfait`, requestOptions).then((response) => {

            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });


                        settypeforfaitsList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get tforfait list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getRevendeursList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&etat=1,2,3,4,5,6,7,8,9`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            // if (element.abrevtypeutilisateur === "RVD") {
                            //     clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });
                            // }
                            clientarraydata.push({ label: element.nom + " " + element.prenom, value: element.codeutilisateur });

                        });

                        setrevendeursList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            console.log("error get reventeurs list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList = async (prevendeur) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${prevendeur}&etat=2`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.nom, value: element.code });
                        });


                        setsitesList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getSiteList2 = async () => {

        if (!user?.isFullAction && !user?.isAdminAction) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.app.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?coderevendeur=${user?.codeutilisateur}&etat=2`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let clientarray = [];

                            clientarray = data?.body?.data;

                            let clientarraydata = [];
                            await clientarray.forEach(element => {
                                clientarraydata.push({ label: element.nom, value: element.code });
                            });


                            setsitesList(clientarraydata);
                        } else {
                            if (data?.body?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("server error", err);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    // console.log("statut error", err);
                }

            }).catch((err) => {
                // console.log("error get client list", err);
                // setError(true);
                // setLoading(false);
            });
        }

    }

    const getHotspotsList = async (psite) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots?codesite=${psite}&etat=1,2`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });


                        sethotspotsList(clientarraydata);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("server error", err);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("statut error", err);
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];
                        let dureee = body?.duree.split(" ");
                        let q = body?.qte.split(" ");
                        // let qj = body?.qtelimitjour.split(" ");

                        setprix(body?.prix !== null ? Number.parseInt(body?.prix) : "");

                        setidrouteur(body?.ids !== null ? body?.ids : "");
                        setlib(body?.lib !== null ? body?.lib : "");
                        setprofile(body?.prof !== null ? body?.prof : "");
                        setdesc(body?.descr !== null ? body?.descr : "");

                        setnbposte(body?.nbposte !== null ? body?.nbposte : 0);
                        setqte(body?.quantite !== null ? q[0] : "");
                        // setqtejour(body?.quantitejour !== null ? qj[0] : "");

                        setduree(body?.duree !== null ? dureee[0] : "");
                        setUnite(body.duree !== null ? {
                            label:
                                dureee[1] === "année(s)"
                                    ? "Année (s)"
                                    : dureee[1] === "mois"
                                        ? "Mois"
                                        : dureee[1] === "jour(s)"
                                            ? "Jour (s)"
                                            : dureee[1] === "heure(s)"
                                                ? "Heure (s)"
                                                : "",
                            value: dureee[1] === "année(s)"
                                ? "years"
                                : dureee[1] === "mois"
                                    ? "months"
                                    : dureee[1] === "jour(s)"
                                        ? "days"
                                        : dureee[1] === "heure(s)"
                                            ? "hours"
                                            : "",
                        } : "");
                        setuniteqte(body.qte !== null ? {
                            label:
                                q[1] === "Mo"
                                    ? "Mo"
                                    : q[1] === "Go"
                                        ? "Go"
                                        : "",
                            value: q[1] === "Mo"
                                ? 0
                                : q[1] === "Go"
                                    ? 1
                                    : "",
                        } : "");

                        // setuniteqtejour(body.qtelimitjour !== null ? {
                        //     label:
                        //         qj[1] === "Mo"
                        //             ? "Mo"
                        //             : qj[1] === "Go"
                        //                 ? "Go"
                        //                 : "",
                        //     value: qj[1] === "Mo"
                        //         ? 0
                        //         : qj[1] === "Go"
                        //             ? 1
                        //             : "",
                        // } : "");
                        settypeforfait(
                            body?.codetforfait ? { label: body?.libtforfait, value: body?.codetforfait, } : ""
                        );
                        sethotspot(
                            body?.codehotspot ? { label: body?.libhotspot, value: body?.codehotspot, } : ""
                        );
                        setsite(
                            body?.codesite ? { label: body?.nomsite, value: body?.codesite, } : ""
                        );
                        setrevendeur(
                            body?.coderevendeur ? { label: body?.nom + " " + body?.prenom, value: body?.coderevendeur, } : ""
                        );
                        setPictureprev(body?.img !== null ? body?.img : "/assets/imgs/no-image.png");
                        setEtat(body?.etat !== null ? body?.etat : 0);
                        setetatdef(body?.etatdef !== null ? body?.etatdef : "Etat");

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        getHotspotsList(body?.codesite);
                        getSiteList(body?.coderevendeur);

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    const handlepicturechange = (e) => {
        const file = e.target.files[0];
        setPicture(file)
        TransformPicture(file);
        // console.log("recto prev", rectoprev)
    };

    const TransformPicture = async (file) => {
        const reader = new FileReader();

        const options = {
            maxSizeMB: config.app.maxsizefileoption,
            maxWidthOrHeight: 500,
            useWebWorker: true
        };

        if (file) {
            if (file.size > config.app.maxsizefile * 1024) {
                setCompressin(true);
                await imageCompression(file, options).then((img) => {
                    reader.readAsDataURL(img);
                    reader.onloadend = () => {
                        setPictureprev(reader.result);
                    };
                });
                setCompressin(false);
            } else {
                reader.readAsDataURL(file);
                reader.onloadend = () => {
                    setPictureprev(reader.result);
                };
            }

        } else {
            setPictureprev("/assets/imgs/no-image.png");
        }
    };

    // comportements
    useEffect(() => {
        getElement();
        getTypeForfaitsList();
        getRevendeursList();
        getSiteList2();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deleteforfaitlabel,
            message: textes.fr.deleteforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (idrouteur) urlencoded.append("id", idrouteur);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.forfaitdeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editforfaitlabel,
            message: textes.fr.editforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (idrouteur) urlencoded.append("id", idrouteur);
                        if (lib) urlencoded.append("lib", lib);
                        if (desc) urlencoded.append("descr", desc);
                        if (profile) urlencoded.append("prof", profile);
                        if (prix) urlencoded.append("prix", prix);
                        if (duree && unite) urlencoded.append("duree", duree + " " + unite["value"]);
                        if (qte) urlencoded.append("qte", qte + " " + uniteqte["label"]);
                        if (qte) urlencoded.append("qtekilo", uniteqte["label"] === "Go" ? qte * 1073741824 : qte * 1048576);
                        if (nbposte) urlencoded.append("nbposte", nbposte);
                        if (qtejour) urlencoded.append("qtelimitjour", qtejour + " " + uniteqtejour["label"]);
                        if (qtejour) urlencoded.append("qtelimitjourkilo", uniteqtejour["label"] === "Go" ? qtejour * 1073741824 : qtejour * 1048576);
                        if (typeforfait) urlencoded.append("codetforfait", typeforfait["value"]);
                        if (hotspot) urlencoded.append("codehotspot", hotspot["value"]);
                        if (picture || pictureprev !== '/assets/imgs/no-image.png') urlencoded.append("img", pictureprev);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);
                        urlencoded.append("etatdef", etatdef);
                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.forfaitupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editforfaitlabel,
            message: textes.fr.editforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setSuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (idrouteur) urlencoded.append("id", idrouteur);
                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Suspendu");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.forfaitupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setSuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setSuspending(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setSuspending(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setSuspending(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editforfaitlabel,
            message: textes.fr.editforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setStarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (idrouteur) urlencoded.append("id", idrouteur);
                        urlencoded.append("etat", "1");
                        urlencoded.append("etatdef", "En service");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/bundles/${codeforfait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.forfaitupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setStarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setStarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setStarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setStarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isModifierForfait) && !editedstate && etat === 2 && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.editforfaitlabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isSupprimerForfait) && !editedstate && etat === 2 && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deleteforfaitlabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isActiverForfait) && !editedstate && etat === 2 && <button onClick={handleStart}
                                            title="Réactiver le forfait"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Activer</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isSuspendreForfait) && !editedstate && etat === 1 && <button onClick={handleSuspende}
                                            title="Suspendre le forfait"
                                            className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        <h5 className="m-0 ">
                                            {textes.fr.forfaitinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <form
                                            style={{ width: "100%" }}
                                            className="mb-3"
                                            onSubmit={handleSubmitEdit}
                                        >
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <div className="row">
                                                        {editedstate && <div className="col-md-12 mb-2">
                                                            <label htmlFor="logo" className="form-label">Image illustrative</label>
                                                            <input className="form-control" type="file" id="logo" onChange={handlepicturechange} />
                                                        </div>}
                                                        {compressing && <div className="col-md-12 p-5 mb-3">
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="lg"
                                                                role="status"
                                                                aria-hidden="true"
                                                                style={{ display: "block", marginLeft: 'auto', marginRight: 'auto' }}
                                                            />
                                                        </div>}
                                                        {!compressing && <div className="col-md-12 mb-3">
                                                            <img alt="" src={pictureprev} className={`rounded `} style={{ width: "100%", border: "1px solid" }} />
                                                        </div>}
                                                    </div>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <div className="row">
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="revendeur" className="mb-1">
                                                                {textes.fr.revendeurlabel}
                                                            </label>
                                                            <Select
                                                                id="revendeur"
                                                                name="revendeur"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={revendeursList}
                                                                value={revendeur}
                                                                onChange={(selected) => {
                                                                    setrevendeur(selected);
                                                                    getSiteList(selected["value"]);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>}
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="site" className="mb-1">
                                                                {textes.fr.sitelabel}
                                                            </label>
                                                            <Select
                                                                id="site"
                                                                name="site"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={sitesList}
                                                                value={site}
                                                                onChange={(selected) => {
                                                                    setsite(selected);
                                                                    getHotspotsList(selected["value"]);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="hotspot" className="mb-1">
                                                                {textes.fr.hotspotlabel}
                                                            </label>
                                                            <Select
                                                                id="hotspot"
                                                                name="hotspot"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={hotspotsList}
                                                                value={hotspot}
                                                                onChange={(selected) => {
                                                                    sethotspot(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="typeforfait" className="mb-1">
                                                                {textes.fr.typeforfaitlabel}
                                                            </label>
                                                            <Select
                                                                id="typeforfait"
                                                                name="typeforfait"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={typeforfaitsList}
                                                                value={typeforfait}
                                                                onChange={(selected) => {
                                                                    settypeforfait(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="lib" className="mb-1">
                                                                Libelle
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="lib"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={lib}
                                                                    onChange={(e) =>
                                                                        setlib(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="profile" className="mb-1">
                                                                Profile
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="profile"
                                                                >
                                                                    <CardText />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={profile}
                                                                    onChange={(e) =>
                                                                        setprofile(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="prix" className="mb-1">
                                                                Prix
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="prix"
                                                                >
                                                                    <Cash />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={prix}
                                                                    onChange={(e) => { setprix(e.target.value) }}
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="duree" className="mb-1">
                                                                {textes.fr.durelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="duree"
                                                                >
                                                                    <Clock />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={duree}
                                                                    onChange={(e) =>
                                                                        setduree(e.target.value)
                                                                    }
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="unite" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="unite"
                                                                name="unite"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unites}
                                                                value={unite}
                                                                onChange={(selected) => {
                                                                    setUnite(selected);
                                                                }}
                                                                isDisabled
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="qte" className="mb-1">Quantité de données</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="qte"
                                                                >
                                                                    <Wifi />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={qte}
                                                                    onChange={(e) =>
                                                                        setqte(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="uniteqte" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="uniteqte"
                                                                name="uniteqte"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unitedatas}
                                                                value={uniteqte}
                                                                onChange={(selected) => {
                                                                    setuniteqte(selected);
                                                                }}
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                        {/* <div className="col-md-6 mb-3">
                                                            <label htmlFor="qtejour" className="mb-1">Quantité de données limite par jour</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="qtejour"
                                                                >
                                                                    <Wifi />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Entrez la durée"
                                                                    value={qtejour}
                                                                    onChange={(e) =>
                                                                        setqtejour(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="uniteqte" className="mb-1">
                                                                Unité
                                                            </label>
                                                            <Select
                                                                id="uniteqte"
                                                                name="uniteqte"
                                                                placeholder="Sélectionner l'unité"
                                                                options={unitedatas}
                                                                value={uniteqtejour}
                                                                onChange={(selected) => {
                                                                    setuniteqtejour(selected);
                                                                }}
                                                                isDisabled={editedstate ? false : true}
                                                            />
                                                        </div> */}
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="nbposte" className="mb-1">Nombre de poste autorisé</label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="nbposte"
                                                                >
                                                                    <PersonWorkspace />
                                                                </span>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nbposte}
                                                                    onChange={(e) =>
                                                                        setnbposte(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="desc" className="mb-1">
                                                                Description
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="desc"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={desc}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setdesc(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-success" :
                                                                            etat === 2 ? "text-white bg-danger" :
                                                                                ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.editforfaitlabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
